module.exports = __webpack_public_path__ + "media/images/covid/vent_ico-ff1cb1d2e06ec9884b4b5ae01ab64653.png";